import { useState } from 'react';

export default function ContactSection() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('phone_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormStatus('success');
      return;
    }
    setFormStatus('success');
    setTimeout(() => {
      setFormStatus('idle');
      form.reset();
    }, 3000);
  };

  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-8 md:gap-12">
          <div className="flex-1 flex flex-col gap-4">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium w-fit">
              <i className="ri-mail-send-line text-sm"></i>
              联系我们
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">我要爆料 / 商务合作</h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[480px]">
              有猛料想爆料？有内容想投稿？欢迎通过以下方式联系我们的编辑团队。我们承诺对爆料人信息严格保密，优质爆料一经采用即付稿酬。
            </p>
            <div className="flex flex-col gap-3 mt-2">
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100">
                  <i className="ri-mail-line text-primary-500 text-lg"></i>
                </span>
                <div>
                  <p className="text-xs text-foreground-500">爆料邮箱</p>
                  <p className="text-sm font-medium text-foreground-800">baoliao@chigua51.com</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100">
                  <i className="ri-wechat-line text-accent-500 text-lg"></i>
                </span>
                <div>
                  <p className="text-xs text-foreground-500">合作微信</p>
                  <p className="text-sm font-medium text-foreground-800">chigua51_BD</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100">
                  <i className="ri-customer-service-2-line text-secondary-500 text-lg"></i>
                </span>
                <div>
                  <p className="text-xs text-foreground-500">客服热线</p>
                  <p className="text-sm font-medium text-foreground-800">400-888-5151</p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1 w-full">
            <form
              data-readdy-form
              onSubmit={handleSubmit}
              className="bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/70 flex flex-col gap-4"
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="flex flex-col gap-1.5">
                  <label htmlFor="contact-name" className="text-xs font-medium text-foreground-600">称呼</label>
                  <input
                    id="contact-name"
                    name="name"
                    type="text"
                    required
                    placeholder="请输入你的称呼"
                    className="px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-300 transition-colors"
                  />
                </div>
                <div className="flex flex-col gap-1.5">
                  <label htmlFor="contact-email" className="text-xs font-medium text-foreground-600">邮箱</label>
                  <input
                    id="contact-email"
                    name="email"
                    type="email"
                    required
                    placeholder="请输入你的邮箱"
                    className="px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-300 transition-colors"
                  />
                </div>
              </div>
              <div className="flex flex-col gap-1.5">
                <label htmlFor="contact-subject" className="text-xs font-medium text-foreground-600">主题</label>
                <input
                  id="contact-subject"
                  name="subject"
                  type="text"
                  required
                  placeholder="请输入主题"
                  className="px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-300 transition-colors"
                />
              </div>
              <div className="flex flex-col gap-1.5">
                <label htmlFor="contact-message" className="text-xs font-medium text-foreground-600">内容</label>
                <textarea
                  id="contact-message"
                  name="message"
                  required
                  rows={4}
                  maxLength={500}
                  placeholder="请输入你想爆料或咨询的内容（500字以内）"
                  className="px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                ></textarea>
              </div>
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="form-honeypot"
              />
              <button
                type="submit"
                className="w-full px-6 py-3 rounded-lg bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                提交信息
              </button>
              {formStatus === 'success' && (
                <p className="text-xs text-accent-600 text-center">提交成功，我们会尽快与你联系！</p>
              )}
              {formStatus === 'error' && (
                <p className="text-xs text-primary-600 text-center">{formError || '提交失败，请稍后重试'}</p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}